import * as MFA_en from './MFA.en.js';
import * as MFA_es from './MFA.es.js';

const MFATuple = [
  { type: 'MFA', language: 'en', object: MFA_en.default },
  { type: 'MFA', language: 'es', object: MFA_es.default },
];

export default MFATuple;
